import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { App } from './App';
import { shouldRetryQuery } from '@/api/client';
import { AuthProvider } from '@/auth/AuthProvider';
import { ErrorFallback } from '@/components/ErrorFallback';
import { initSentry } from '@/config/sentry';
import '@/i18n';
import '@/utils/pageTranslatorDom';
import { applyTheme, readStoredTheme } from '@/utils/theme';
import { THEME_STORAGE_KEY } from '@/types/theme';

initSentry();
applyTheme(readStoredTheme(THEME_STORAGE_KEY));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: shouldRetryQuery },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
